<template>
    <a href="#" @click.prevent="showModal" target="_blank" class="button blue">
        <span class="icon"><i class="mdi mdi-plus"></i></span>
        <span>Add an Influencer</span>
    </a>

    <modal v-show="isModalVisible"
           @close="closeModal" :is-active="isModalVisible">
        <template v-slot:header>Add a Referrer (Market Influencer)</template>
        <template v-slot:body>
            <div class="mb-6">
                <div class="card-content">
                    <form @submit.prevent="addNewReferrer" class="md:rounded border-0 dark:bg-gray-900/70 bg-white border dark:border-0">
                        <div class="field">
                            <label class="label">Name</label>
                            <div class="field-body">
                                <div class="field">
                                    <div class="control icons-left">
                                        <input v-model="form.name" required class="px-3 py-2 max-w-full focus:ring focus:outline-none border-gray-700 rounded w-full dark:placeholder-gray-400 h-12 border bg-white dark:bg-gray-800 pl-10" type="text"
                                               placeholder="Referrer Name">
                                        <span class="icon left"><i class="mdi mdi-account"></i></span>
                                    </div>
                                </div>
                            </div>
                        </div>

<!--                        <div class="field">-->
<!--                            <label class="label">Code</label>-->
<!--                            <div class="field-body">-->
<!--                                <div class="field">-->
<!--                                    <div class="control icons-left">-->
                                        <input v-model="form.username" required class="px-3 py-2 max-w-full focus:ring focus:outline-none border-gray-700 rounded w-full dark:placeholder-gray-400 h-12 border bg-white dark:bg-gray-800 pl-10" type="hidden" readonly
                                               placeholder="Referrer Code">
<!--                                        <span class="icon left"><i class="mdi mdi-barcode"></i></span>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->

                        <div class="field">
                            <label class="label">Email Address</label>
                            <div class="field-body">
                                <div class="field">
                                    <div class="control icons-left">
                                        <input v-model="form.email" required class="px-3 py-2 max-w-full focus:ring focus:outline-none border-gray-700 rounded w-full dark:placeholder-gray-400 h-12 border bg-white dark:bg-gray-800 pl-10" type="email"
                                               placeholder="referrer...@host.com">
                                        <span class="icon left"><i class="mdi mdi-mail"></i></span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="field">
                            <label class="label">Phone Number(Optional if Email available)</label>
                            <div class="field-body">
                                <div class="field">
                                    <div class="control icons-left">
                                        <input v-model="form.phone" class="px-3 py-2 max-w-full focus:ring outline-none focus:outline-none border-gray-700 rounded w-full dark:placeholder-gray-400 h-12 border bg-white dark:bg-gray-800 pl-10" type="tel"
                                               placeholder="+256 779 -- -- --">
                                        <span class="icon left"><i class="mdi mdi-phone"></i></span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="field grouped">
                            <div class="control">
                                <button type="submit" class="button green">
                                    Submit
                                </button>
                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </template>
    </modal>

</template>

<script>
import Modal from "@/Components/Modal";

export default {
    name: "NewReferrer",
    components: {Modal},
    data() {
        return {
            isModalVisible: false,
            form: this.$inertia.form({
                name: '',
                username: '',
                phone: '',
                email: ''
            })
        }
    },
    methods: {
        showModal() {
            this.isModalVisible = true;
        },
        closeModal() {
            this.isModalVisible = false;
        },
        addNewReferrer() {
            this.form.post(route('referrers.store'), {
                onFinish: () => {
                    this.form.reset();
                    this.closeModal()
                }
            });
        },
        generateReferrerCode() {
            // var randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let randomChars = this.form.name.replace(/\s+/g, '');
            randomChars = randomChars.replace(/[^a-zA-Z ]/g, "");//remove special characters
            let randomNumbers = '0123456789';
            let result = '';
            if (randomChars) {
                //pick a random number
                result += randomNumbers.charAt(Math.floor(Math.random() * randomNumbers.length));

                //pick 2 letters from the campaign name
                for (let i = 0; i < 3; i++) {
                    result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
                }
            }
            if (randomChars)
                return result.toUpperCase();
            else return '';
        },
    },
    computed: {
        name() {
            return this.form.name;
        }
    },
    watch: {
        name: _.debounce(function () {
            this.form.username = this.generateReferrerCode()
        }, 1000),
    }
}
</script>

<style scoped>
.dp__theme_dark {
    --dp-background-color: rgba(31, 41, 55, 1);
    --dp-text-color: #ffffff;
    --dp-hover-color: #484848;
    --dp-hover-text-color: #ffffff;
    --dp-hover-icon-color: #959595;
    --dp-primary-color: #005cb2;
    --dp-primary-text-color: #ffffff;
    --dp-secondary-color: #a9a9a9;
    --dp-border-color: rgba(55, 65, 81,1);
    --dp-menu-border-color: #2d2d2d;
    --dp-border-color-hover: #aaaeb7;
    --dp-disabled-color: #737373;
    --dp-scroll-bar-background: #212121;
    --dp-scroll-bar-color: #484848;
    --dp-success-color: #00701a;
    --dp-success-color-disabled: #428f59;
    --dp-icon-color: #959595;
    --dp-danger-color: #e53935;
}
</style>
